module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "menu-item",
    class: {
      english: (_vm.language === "en")
    }
  }, [(_vm.language === "nl") ? _c('router-link', {
    attrs: {
      "to": {
        name: 'programma',
        params: {
          language: 'nl',
          slug: ''
        }
      }
    }
  }, [_vm._v("Programma")]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('router-link', {
    attrs: {
      "to": {
        name: 'programma',
        params: {
          language: 'en',
          slug: ''
        }
      }
    }
  }, [_vm._v("Programme")]) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('router-link', {
    attrs: {
      "to": {
        name: 'overons',
        params: {
          language: 'nl',
          slug: ''
        }
      }
    }
  }, [_vm._v("Over ons")]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('router-link', {
    attrs: {
      "to": {
        name: 'overons',
        params: {
          language: 'en',
          slug: ''
        }
      }
    }
  }, [_vm._v("About")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9029f210!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsMenu.vue
// module id = 223
// module chunks = 2